module.exports = __webpack_public_path__ + "img/accounts.3e01c7ce.png";